module.exports = __webpack_public_path__ + "img/pin-fill.c3e47f89.svg";